import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './intl/en/translations.json';
import nlTranslations from './intl/nl/translations.json';

// Check if we're running in browser environment
const isBrowser = typeof window !== 'undefined';

// Create a simple i18n instance that works in browser and server
const createI18n = () => {
  // Create a new instance
  const instance = i18n.createInstance();
  
  // Basic configuration options
  const options = {
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: enTranslations
      },
      nl: {
        translation: nlTranslations
      }
    },
    react: {
      useSuspense: false, // Important for Gatsby
    }
  };

  // Add browser-specific options
  if (isBrowser) {
    options.detection = {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    };
    
    instance.use(LanguageDetector);
  }
  
  // Initialize with React
  instance.use(initReactI18next).init(options);
  
  return instance;
};

// Create the i18n instance
const i18nInstance = createI18n();

// Log initialization in browser
if (isBrowser) {
  console.log('i18n initialized in browser with language:', i18nInstance.language);
}

// Expose a helper function to get a translation
export const t = (key, options = {}) => {
  if (!i18nInstance) return key;
  
  try {
    return i18nInstance.t(key, options);
  } catch (error) {
    console.error('Translation error:', error);
    return key;
  }
};

// Helper for changing language
export const changeLanguage = (lng) => {
  console.log('changeLanguage helper called with:', lng);
  
  // Early return if not in browser
  if (!isBrowser) {
    console.log('Not in browser, skipping language change');
    return Promise.resolve();
  }
  
  // Safety check for i18n instance
  if (!i18nInstance) {
    console.error('i18n instance not available');
    return Promise.resolve();
  }
  
  try {
    // Attempt to change language
    console.log('Changing language via i18nInstance to:', lng);
    return i18nInstance.changeLanguage(lng)
      .then(() => {
        // Store in localStorage for persistence
        localStorage.setItem('i18nextLng', lng);
        console.log('Language changed successfully, new language:', i18nInstance.language);
        return Promise.resolve(lng);
      })
      .catch(err => {
        console.error('Error in changeLanguage:', err);
        return Promise.reject(err);
      });
  } catch (error) {
    console.error('Exception in changeLanguage:', error);
    return Promise.reject(error);
  }
};

// Export the instance
export default i18nInstance;